import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "disabled", "label", "description", "className"];
import { jsxs, jsx } from 'react/jsx-runtime';
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { TextWithInfoBadge } from '../util-components/text-with-info-badge/text-with-info-badge.js';
import { useUniqueId } from '../utils/useUniqueId.js';
import styles from './radio-group.module.js';
var RadioItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var value = props.value,
      disabled = props.disabled,
      label = props.label,
      description = props.description,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var descriptionId = useUniqueId('description-', !!description);
  return jsxs("div", {
    className: clsx([styles.radioOption], _defineProperty({}, styles.disabled, disabled), className),
    children: [jsxs("label", {
      className: styles.label,
      children: [jsx(RadixRadioGroup.Item, _objectSpread(_objectSpread({}, rest), {}, {
        ref: ref,
        "aria-describedby": descriptionId,
        className: styles.radioButton,
        disabled: disabled,
        value: value,
        children: jsx(RadixRadioGroup.Indicator, {
          className: styles.indicator,
          forceMount: true
        })
      })), label]
    }), description ? jsx("div", {
      className: styles.description,
      children: jsx(TextWithInfoBadge, {
        id: descriptionId,
        variant: "muted",
        children: description
      })
    }) : null]
  });
});
RadioItem.displayName = 'RadioItem';
export { RadioItem };